export enum InvestPoolType {
  PromptPay = "PromptPay",
}

export const InvestPoolTypes = Object.values(InvestPoolType);
